export default function AskDemo() {
  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h1>Ask for a Demo</h1>
      <p>This page lets users request a demo. Form can be added later.</p>
    </div>
  );
}
